import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatbotConfig } from '@shared/index';
import { AdminService } from '@shared-angular/services/admin.service';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { TextareaModule } from 'primeng/textarea';
import { RouteShareService } from '../../services/route-share.service';

@Component({
  selector: 'app-bot-image-reload',
  imports: [FormsModule, ButtonModule, PopoverModule, TextareaModule],
  templateUrl: './bot-image-reload.component.html'
})
export class BotImageReloadComponent {
  // 'closed' = Basis-Bild (Standard), 'open' = zusätzliches Bild für den geöffneten Fusion-View-Zustand
  @Input() public variant: 'closed' | 'open' = 'closed';

  public loading = false;
  public customPrompt = '';

  constructor(private adminService: AdminService, public rss: RouteShareService) { }

  public get hasImage(): boolean {
    return this.variant === 'open' ? this.rss.botConfig.hasImageOpen : this.rss.botConfig.hasImage;
  }

  public async deleteImage() {
    const newConfig: ChatbotConfig = await this.adminService.deleteImage(this.rss.botConfig._id, this.variant === 'open' ? 'open' : undefined);
    this.rss.botConfig = newConfig;
    this.rss.botImageCacheBuster = Date.now();
  }

  public async reloadImage() {
    this.loading = true;
    let p: string;
    if (this.customPrompt.trim() !== '') {
      p = this.customPrompt.trim();
    } else {
      let tmpInstr = this.rss.botConfig.botInstruction;
      if (tmpInstr.length > 500) {
        tmpInstr = tmpInstr.substring(0, 500);
      }
      p = 'Eine Visualisierung zu einem BOT mit dem Name "' + this.rss.botConfig.name + '". Er hat die folgende Funktion: ' + tmpInstr;
    }
    const newConfig: ChatbotConfig = await this.adminService.reloadImage(this.rss.botConfig._id, p, this.variant === 'open' ? 'open' : undefined);
    this.loading = false;
    this.customPrompt = '';
    this.rss.botConfig = newConfig;
    this.rss.botImageCacheBuster = Date.now();
  }

  public async setImageFromSkill(skillId: string) {
    this.loading = true;
    const newConfig: ChatbotConfig = await this.adminService.setImageFromSkill(this.rss.botConfig._id, skillId, this.variant === 'open' ? 'open' : undefined);
    this.loading = false;
    this.rss.botConfig = newConfig;
    this.rss.botImageCacheBuster = Date.now();
  }
}
